import { z } from 'zod';

/**
 * AI Provider Schemas
 * AI provider management, status, and configuration
 */

// === AI Provider Value Objects ===

export const AIProviderIdSchema = z.string()
  .min(1, { message: "AI provider ID cannot be empty" })
  ;

export const AIProviderNameSchema = z.string()
  .min(1, { message: "AI provider name cannot be empty" })
  ;

// === AI Provider Status Enums ===

export const AIProviderStatusSchema = z.enum(['active', 'inactive'], {
  error: "Invalid AI provider status. Must be one of: active, inactive"
});

export const AIProviderTypeSchema = z.enum(['fal', 'openrouter'], {
  error: "Invalid AI provider type. Must be one of: fal, openrouter"
});

// Export TypeScript types
export type AIProviderId = z.infer<typeof AIProviderIdSchema>;
export type AIProviderName = z.infer<typeof AIProviderNameSchema>;
export type AIProviderStatus = z.infer<typeof AIProviderStatusSchema>;
export type AIProviderType = z.infer<typeof AIProviderTypeSchema>;
